import CookieStorage from '@common/storage/cookieStorage'
import StorageFeatureDetection from '@common/storage/storageFeatureDetection'

export default class StorageFactory {
  static getStorage() {
    return StorageFeatureDetection.isEnabled('localStorage') ? localStorage : CookieStorage
  }
}
